import { IconButton } from '@braskai/ui-kit';

import { css, styled } from '@mui/material';

export const SIconMenu = styled(IconButton)(
  ({ theme }) => css`
    background-color: ${theme.palette.common.white};
    border-radius: 6px;
    color: ${theme.palette.grey[900]};

    &:hover {
      background: ${theme.palette.common.white};
    }
  `,
);
